
const GlitchStyles = () => {
  return (
    <style>{`
      @keyframes glitch {
        0%, 14%, 15%, 49%, 50%, 99%, 100% {
          transform: translate3d(0, 0, 0) rotateX(0deg);
          filter: drop-shadow(0 0 8px rgba(34, 197, 94, 0.7));
        }
        1%, 13%, 16%, 48%, 51%, 98% {
          transform: translate3d(-2px, 0, 0) rotateX(0deg);
          filter: drop-shadow(0 0 12px rgba(34, 197, 94, 0.9)) drop-shadow(0 0 4px rgba(255, 255, 255, 0.3));
        }
        2%, 12%, 17%, 47%, 52%, 97% {
          transform: translate3d(2px, 0, 0) rotateX(0deg);
          filter: drop-shadow(0 0 12px rgba(34, 197, 94, 0.9)) drop-shadow(0 0 4px rgba(255, 255, 255, 0.3));
        }
        3%, 11%, 18%, 46%, 53%, 96% {
          transform: translate3d(-1px, 0, 0) rotateX(0deg);
          filter: drop-shadow(0 0 15px rgba(34, 197, 94, 1)) drop-shadow(0 0 8px rgba(255, 255, 255, 0.5));
        }
      }
    `}</style>
  );
};

export default GlitchStyles;
